var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"relative"},[_vm._t("label",function(){return [(_vm.showLabel && _vm.label)?_c('div',{staticClass:"mx-auto"},[_c('FieldLabel',_vm._b({staticClass:"pl-1"},'FieldLabel',{ label: _vm.label },false))],1):_vm._e()]}),_vm._v(" "),_vm._t("anchor"),_vm._v(" "),_c('transition',{attrs:{"name":"dropdown"}},[_c('aside',{ref:"popup",staticClass:"absolute my-2 rounded-md border bg-white shadow-lg z-10 overflow-hidden",class:[
        _vm.open ? '' : 'hidden',
        _vm.menuPaddingClass,
        _vm.menuBorderClass,
        _vm.alignmentStyle,
        _vm.placementStyle,
        _vm.useContainerWidth ? 'w-full' : '',
      ],style:(_vm.useContainerWidth
          ? {}
          : {
              width: `${_vm.calculatedMenuWidth}px`,
              transform: _vm.useMenuOffset ? `translateX(${_vm.offset}px)` : '',
            })},[_c('div',{class:[_vm.menuHeight ? 'overflow-y-auto' : ''],style:({
          'max-height': _vm.menuHeight ? _vm.menuHeight : '',
        })},[_vm._t("content")],2)])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }